import { FC } from 'react';

import { Block, BlockHeader } from '../../../../../shared/lib/ui';
import S from './HowItWorks.module.scss';
import { useTranslation } from 'react-i18next';

export const HowItWorks: FC = () => {
  const { t, i18n } = useTranslation();
  const locale = i18n.resolvedLanguage;

  return (
    <section>
      <BlockHeader
        block={t('webmaster.how_it_work_section.title')}
        title={t('webmaster.how_it_work_section.subtitle')}
      />
      <div className={S.Blocks}>
        <Block
          title={t('webmaster.how_it_work_section.card_1.title')}
          descr={
            <span className={S.Title}>
              {t('webmaster.how_it_work_section.card_1.description')}
            </span>
          }
          img={`/assets/img/publishers/image-login-${locale || 'ru'}.png`}
          action={t('webmaster.how_it_work_section.card_1.button')}
          color="violet"
          href="/sign-up/webmaster"
        />
        <Block
          title={t('webmaster.how_it_work_section.card_2.title')}
          descr={t('webmaster.how_it_work_section.card_2.description')}
          img={`/assets/img/publishers/image-code-${locale || 'ru'}.png`}
          action={t('webmaster.how_it_work_section.card_2.button')}
          color="white"
          href="/sign-up/webmaster"
        />
        <Block
          title={t('webmaster.how_it_work_section.card_3.title')}
          descr={t('webmaster.how_it_work_section.card_3.description')}
          img={`/assets/img/publishers/image-payments-${locale || 'ru'}.png`}
          action={t('webmaster.how_it_work_section.card_3.button')}
          color="white"
          href="/sign-up/webmaster"
        />
      </div>
    </section>
  );
};
